<template>
    <Teleport to="body">
        <div
            :id="id"
            ref="tooltipRef"
            role="tooltip"
            class="ds-month-tooltip"
            :style="{ left: `${position.left}px`, top: `${position.top}px`, visibility: position.ready ? 'visible' : 'hidden' }"
        >
            <span class="ds-month-tooltip-title">{{ title }}</span>

            <div v-if="dayState" class="ds-month-tooltip-day-state">
                <span class="ds-month-tooltip-day-state-name" :style="{ backgroundColor: dayState.color }">{{ dayState.name }}</span>
            </div>

            <div v-if="rows.length" class="ds-timesheet-tooltip-rows">
                <template v-for="row in rows" :key="row.label">
                    <span class="ds-month-tooltip-label" :class="{ 'ds-timesheet-tooltip-label-nested': row.nested }">{{ row.label }}</span>
                    <span class="ds-timesheet-tooltip-value" :class="{ 'ds-timesheet-tooltip-value-extra': row.extra }">{{ row.value }}</span>
                </template>
            </div>

            <template v-if="shifts.length">
                <div class="ds-month-tooltip-divider" />
                <div class="ds-timesheet-tooltip-shifts">
                    <span v-for="shift in shifts" :key="shift.key">{{ shift.text }}</span>
                </div>
            </template>

            <template v-if="total || chips.length">
                <div class="ds-month-tooltip-divider" />
                <div class="ds-month-tooltip-footer">
                    <span v-if="total" class="ds-month-tooltip-total">Итого {{ total }}</span>
                    <span v-else />
                    <span v-if="chips.length" class="ds-month-tooltip-chips justify-end">
                        <span
                            v-for="chip in chips"
                            :key="chip.text"
                            class="ds-month-tooltip-chip"
                            :class="chip.kind === 'violation' ? 'ds-month-tooltip-chip-violation' : 'ds-month-tooltip-chip-ok'"
                        >{{ chip.text }}</span>
                    </span>
                </div>
            </template>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
import { nextTick, onMounted, reactive, ref, watch } from 'vue'
import { placeCellTooltip } from '@/components/schedule/weekSchedule'

export interface TimesheetTooltipRow {
    label: string
    value: string
    extra?: boolean
    nested?: boolean
}

interface Props {
    id: string
    anchor: HTMLElement
    title: string
    dayState: { name: string, color: string } | null
    rows: TimesheetTooltipRow[]
    shifts: { key: string, text: string }[]
    total: string
    chips: { text: string, kind: 'violation' | 'ok' }[]
}

const props = defineProps<Props>()

const tooltipRef = ref<HTMLElement | null>(null)
const position = reactive({ left: 0, top: 0, ready: false })

function place() {
    const element = tooltipRef.value
    if (!element) return
    Object.assign(position, placeCellTooltip(element, props.anchor), { ready: true })
}

onMounted(place)

// Содержимое может измениться при фоновом обновлении данных — пересчитываем размер и позицию.
watch(() => [props.rows, props.shifts, props.chips, props.total, props.dayState], () => nextTick(place), { deep: true })
</script>
